module.exports = __webpack_public_path__ + "static/media/tunnel.fdf6cd70.mov";